import classNames from 'classnames';
import { BlockBody, BlockHeader } from '@medifind/containers';
import { AreasOfExpertise, MFLink } from '@medifind/shared-basic-components';
import { ConditionAvailability } from './condition-availability';
import styles from './AreasOfExpertiseBlock.module.scss';

const AreasOfExpertiseBlock = ({ areasOfExpertise, personId, headerPriority, displayName, conditions, classes = {} }) => {
  return (
    <>
      <BlockHeader priority={headerPriority} className={classes.blockHeader}>
        Areas of Expertise
      </BlockHeader>
      <BlockBody className={classNames(styles['areas-of-expertise'], classes.blockBody)}>
        <p>
          When evaluating expertise, MediFind pulls from factors such as the number of articles a doctor has published in medical journals,
          participation in clinical trials, speaking at industry conferences, prescribing and referral patterns, and strength of connections
          with other experts in their field.
        </p>
        <p>
          To learn more about how MediFind determines the expertise levels,{' '}
          <MFLink href={'/how-medifind-works'}>check out our expert tiers page</MFLink>.
        </p>
        {personId ? <ConditionAvailability displayName={displayName} personId={personId} conditions={conditions} /> : null}
        <AreasOfExpertise
          bigBars
          areasOfExpertise={areasOfExpertise}
          hideHeader
          classes={{
            label: styles['areas-of-expertise__label'],
            list: styles['areas-of-expertise__list'],
            item: styles['areas-of-expertise__item'],
          }}
        />
      </BlockBody>
    </>
  );
};

export { AreasOfExpertiseBlock as default, AreasOfExpertiseBlock };
